import { IController, IWindowService } from 'angular';

import { SdcWizardStepperService } from '../../../../../shared/services/sdc/sdc-wizard-stepper.service';
import { ISdcStore } from './../../../../../sdc/flux/sdc-store.interface';

const sdcKey = 'regents-planning';

export class RegentsPlanningStepperCtrl implements IController {
  static $inject: string[] = ['$scope', 'SDCStore', 'SdcWizardStepperService', '$window'];

  // bindings
  public stepper: any;
  public uiReady: boolean = false;
  public prevStep;
  public nextStep;

  // class properties
  constructor(
    private $scope,
    private SDCStore: ISdcStore,
    private SdcWizardStepperService: SdcWizardStepperService,
    private $window: IWindowService,
  ) {
    this.prevStep = this.SdcWizardStepperService.back;
    this.nextStep = this.SdcWizardStepperService.next;
  }

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) {
        this.$window.setTimeout(() => this.SdcWizardStepperService.init(sdcKey));
        this.uiReady = true;
      }
    });
  }
}
